<template>
  <div class="home">
    <div class="blocco">
      <img v-if="$store.state.mode == 'foot'" src="../assets/infofoot.png" style="max-height: 90%" />
      <img v-if="$store.state.mode == 'bike'" src="../assets/infobici.png" style="max-height: 90%" />
    </div>
    <div class="blocco">
      <img src="../assets/switchsegnalaoff.png" style="width:110%" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
  mounted() {
    this.$store.commit("completeTutorial")
  }
};
</script>

<style lang="less" scoped>
.home {
  padding-top: 20px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
}
.blocco {
  height: 112px;

  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
